<template>
  <LoadingSpinner v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12">
                <h6>
                  <b
                    >{{ cliente.nombre }} {{ cliente.paterno }}
                    {{ cliente.materno }}</b
                  >
                </h6>
              </div>
            </div>
          </div>

          <ul
            class="nav nav-pills bg-white nav-fill mb-3 px-3 pt-4"
            id="pills-tab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active shadow btn-sm"
                id="pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                <i class="ri-user-line me-1"></i>
                Datos generales
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link shadow btn-sm"
                id="pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-profile"
                type="button"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                <i class="ri-user-add-line me-1"></i>
                Información adicional
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link shadow btn-sm"
                id="pills-contact-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-contact"
                type="button"
                role="tab"
                aria-controls="pills-contact"
                aria-selected="false"
              >
                <i class="ri-user-star-line me-1"></i>
                Obligados solidarios
              </button>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <form-cliente
                :cliente="cliente"
                :estados="estados"
                :municipios="municipios"
                modo="editar"
              />
            </div>
            <div
              class="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <form-cliente-detalle
                v-if="cliente_detalle !== null"
                :clienteDetalle="cliente_detalle"
                :cliente="cliente"
                modo="editar"
              />
              <form-cliente-detalle v-else :cliente="cliente" modo="crear" />
            </div>
            <div
              class="tab-pane fade"
              id="pills-contact"
              role="tabpanel"
              aria-labelledby="pills-contact-tab"
            >
              <cliente-obligados :cliente="cliente" :clienteObligados="cliente_obligados" :estados="estados" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
import FormCliente from "./components/FormCliente.vue";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import FormClienteDetalle from "./components/FormClienteDetalle";
import ClienteObligados from "./components/ClienteObligados";

export default {
  name: "editar-cliente",
  components: {
    FormCliente,
    LoadingSpinner,
    FormClienteDetalle,
    ClienteObligados,
  },
  data() {
    return {
      estados: [],
      municipios: [],
      showSpinnerMunicipio: false,
      isLoadingSubmit: false,
      nombre: "",
      paterno: "",
      materno: "",
      correo: "",
      celular: "",
      telefono: "",
      rfc: "",
      empresa: "",
      tipo_persona: "",
      estado: "",
      municipio: "",
      cliente: [],
      cliente_detalle: [],
      cliente_obligados: [],
      loadingPage: true,
    };
  },
  methods: {
    async getEstados() {
      const response = await appApi().get("estados");
      this.estados = response.data;
    },

    async getMunicipiosByEstado(estado_id) {
      try {
        this.municipios = [];
        this.showSpinnerMunicipio = true;
        const response = await appApi().get(`municipios/${estado_id}`);
        this.municipios = response.data;
        this.showSpinnerMunicipio = false;
        return response.data;
      } catch (e) {
        this.showSpinnerMunicipio = false;
        console.error(e);
      }
    },

    async storeCliente() {
      this.isLoadingSubmit = true;
      const form = document.getElementById("form-create");
      const formData = new FormData(form);

      try {
        const response = await appApi().post("clientes/store", formData);
        const { status, message } = response.data;

        if (!status) {
          this.isLoadingSubmit = false;
          showToast(message, "error");
          return;
        }

        showToast(message, "success");
        this.$router.push({
          name: "clientes",
        });
      } catch (e) {
        this.isLoadingSubmit = false;
        exceptionRequestMsg(e);
      }
    },

    async getCliente() {
      const { cliente_id } = this.$route.params;
      try {
        const response = await appApi().get(`clientes/edit/${cliente_id}`);
        const { cliente, cliente_detalle, cliente_obligados } = response.data;
        const { estado_id } = cliente;
        const municipios = await this.getMunicipiosByEstado(estado_id);
        this.cliente = cliente;
        this.cliente_detalle = cliente_detalle;
        this.cliente_obligados = cliente_obligados;
        this.municipios = municipios;
        this.loadingPage = false;
      } catch (e) {
        exceptionRequestMsg(e);
      }
    },
  },
  async created() {
    await this.getEstados();
    await this.getCliente();
  },
};
</script>
